/* eslint-disable import/prefer-default-export */

import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  /* root: {
        '& > *': {
            margin: theme.spacing(1),
            width: '25ch',
        },
    }, */
  contentSearch: {
    margin: 7,
  },
  formControl: {
    margin: theme.spacing(1),
    width: '15.1%',
    minWidth: '11.1%',
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  formControlSearch: {
    marginTop: 20,
  },
}));
